module.exports = __webpack_public_path__ + "img/metro.2901bd7a.svg";